var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("p", { staticClass: "card-header-title" }, [
        _vm._v("Renombrar " + _vm._s(this.esCarpeta ? "carpeta" : "documento")),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "field has-addons" }, [
        _c("p", { staticClass: "control is-expanded" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newNombre,
                expression: "newNombre",
              },
            ],
            ref: "nombre",
            staticClass: "input",
            attrs: {
              type: "text",
              required: "",
              placeholder: `${
                this.esCarpeta ? "Nueva carpeta" : "Nuevo documento"
              }...`,
            },
            domProps: { value: _vm.newNombre },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.renombrarDocumento.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.newNombre = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.extension
          ? _c("p", { staticClass: "control" }, [
              _c("a", { staticClass: "button is-static" }, [
                _vm._v("\n          " + _vm._s(_vm.extension) + "\n        "),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.renombroInvalidoMessage
        ? _c("p", { staticClass: "help has-text-danger" }, [
            _vm._v(_vm._s(_vm.renombroInvalidoMessage)),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass: "card-footer-item",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      !_vm.renombroInvalido
        ? _c(
            "a",
            {
              staticClass: "card-footer-item has-text-weight-bold is-uppercase",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.renombrarDocumento.apply(null, arguments)
                },
              },
            },
            [_vm._v("Renombrar")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }